// utils.ts
export class Utils {
  static numbers(config: { count: number; min: number; max: number }): number[] {
    const { count, min, max } = config;
    const data = [];
    for (let i = 0; i < count; i++) {
      data.push(Math.floor(Math.random() * (max - min + 1)) + min);
    }
    return data;
  }

  static months(config: { count: number }): string[] {
    const { count } = config;
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months.slice(0, count);
  }

  static CHART_COLORS = {
    red: 'rgba(255, 99, 132, 0.2)',
    blue: 'rgba(54, 162, 235, 0.2)',
    green: 'rgba(75, 192, 192, 0.2)',
  };
}
